const prefix = process.env.NODE_ENV === 'development' ? 'document-manager' : 'document-manager';

export const post_document = `${prefix}/storage`;
export const get_document = (url) => `${prefix}${url}`;
